import type { ReactNode } from 'react';
import type { PopoverItemBaseProps } from '../../Popover/PopoverItem/PopoverItem';
import type { TopbarActionButtonProps } from './base/TopbarActionButton';

import TopbarActionButton from './base/TopbarActionButton';

interface TopbarSynchronizationButtonProps extends PopoverItemBaseProps {
  /**
   * On topbar synchronization button click
   */
  onClick: () => void;
  /**
   * Button label
   */
  label?: ReactNode;
}

const TopbarSynchronizationButton = ({
  onClick,
  label,
  ...props
}: TopbarSynchronizationButtonProps & TopbarActionButtonProps) => {
  return (
    <TopbarActionButton
      onClick={onClick}
      color="blue"
      label={label}
      additionalIconClasses="ml-0.5 mr-3"
      {...props}
    />
  );
};

export default TopbarSynchronizationButton;
